var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBtnDownload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "wee3a",
    d: "M1468 2620v4a2 2 0 0 1-2 2h-14a2 2 0 0 1-2-2v-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wee3b",
    d: "M1454 2615l5 5 5-5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wee3c",
    d: "M1459 2620v-12"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1449 -2607)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    xlinkHref: "#wee3a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1449 -2607)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    xlinkHref: "#wee3b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1449 -2607)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    xlinkHref: "#wee3c"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBtnDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/btn-download.d1916b9b471352fe7d5d998312dcf78e.svg";